import { useState, useEffect } from 'react';

export type Breakpoint = 'desktop' | 'laptop' | 'smallLaptop' | 'tablet' | 'mobile';

function getBreakpoint(width: number): Breakpoint {
  if (width >= 1920) return 'desktop';
  if (width >= 1366) return 'laptop';
  if (width >= 1024) return 'smallLaptop';
  if (width >= 768) return 'tablet';
  return 'mobile';
}

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(() => getBreakpoint(window.innerWidth));

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const onResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setBp(getBreakpoint(window.innerWidth)), 150);
    };
    window.addEventListener('resize', onResize);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return bp;
}
